import {stringify} from 'query-string';
import {get} from 'svelte/store';
import {mc} from '@/core';
import {PATHS} from '@/const/paths';
import {LINKS} from '@/const/link';
import {bridge} from '@/helper/bridge';
import {popupUtil} from '@/helper/popup';
import {IP_RESTRICTED_CODE} from '@/emum';
import {envUtil} from '@/helper/env';
import {appVersion$} from '@/store/app';
import {TaskStatus} from './const';
import RegisterTips from '@/modules/register/popups/RegisterTips.svelte';
import lang from './BonusPage.lang';

export function genButtonHandler(fixLink, type) {
  return {
    earn() {
      if (envUtil.isApp) {
        window.location.assign(fixLink(PATHS.EARN.pathname) + '?' + stringify({tab: 'Promotion'}));
        return;
      }
      window.open(fixLink(PATHS.EARN.pathname) + '?' + stringify({tab: 'Promotion'}));
    },
    checkVoucher() {
      const url = fixLink(PATHS.BONUS.pathname + '?tab=rewards&rewardType=voucher');
      if (envUtil.isApp) {
        window.location.assign(url);
        return;
      }
      window.location.assign(url);
    },
    copyTrading() {
      if (envUtil.isApp) {
        if (versionToNum(get(appVersion$)) >= versionToNum('3.4.0')) {
          bridge.postMessage('toCopyTrading');
          return;
        }
        window.location.assign(fixLink(PATHS.COPY_TRADING_LIST.pathname + '?t=r'));
        return;
      }
      window.open(fixLink(PATHS.COPY_TRADING_LIST.pathname + '?t=r'));
    },
    deposit() {
      if (envUtil.isApp) {
        bridge.postMessage('toDeposit');
        return;
      }
      window.open(fixLink(PATHS.ASSETS_DEPOSIT.pathname) + '?' + stringify({currency: 'BTC'}));
    },
    learnAndEarn() {
      if (envUtil.isApp) {
        window.location.assign(fixLink(PATHS.LEARN_CRYPTO.pathname));
        return;
      }
      window.open(fixLink(PATHS.LEARN_CRYPTO.pathname));
    },
    simulatedTrading() {
      if (envUtil.isApp) {
        window.location.assign(LINKS.MOCK_TRADE);
        return;
      }
      window.open(fixLink(LINKS.MOCK_TRADE));
    },
    spot() {
      if (envUtil.isApp) {
        bridge.postMessage('toSpotTrade');
        return;
      }
      window.open(fixLink(LINKS.SPOT_TRADE));
    },
    contract() {
      if (envUtil.isApp) {
        bridge.postMessage('toContractTrade');
        return;
      }
      window.open(fixLink(LINKS.PHEMEX_CONTRACT_INVERSE_TRADE));
    },
    invite() {
      if (envUtil.isApp) {
        window.location.assign(fixLink(PATHS.ACCOUNT_INVITE_FRIENDS.pathname));
        return;
      }
      window.open(fixLink(PATHS.ACCOUNT_INVITE_FRIENDS.pathname));
    },
    martinUsd() {
      if (envUtil.isApp) {
        window.location.assign(fixLink(LINKS.PHEMEX_CONTRACT_TRADE_USDS_MARTIN));
        return;
      }
      window.location.assign(fixLink(LINKS.PHEMEX_CONTRACT_TRADE_USDS_MARTIN));
    },
    seeVip() {
      if (envUtil.isApp) {
        window.location.assign(fixLink(LINKS.VIP_PORTAL));
        return;
      }
      window.location.assign(fixLink(LINKS.VIP_PORTAL));
    },
  }[type];
}

export async function sendRequest(requestPromise, LG) {
  const {data, error} = await requestPromise;
  if (error) {
    if ([IP_RESTRICTED_CODE.RESTRICTED, IP_RESTRICTED_CODE.WARNING].includes(error.code)) {
      popupUtil.create(RegisterTips, {LG});
      return {error};
    }
    mc.send('toast', 'error', error);
    return {error};
  }
  return {data};
}

export function linkWrapper(link, text, color = 'var(--blue-main)') {
  return `<a target='${envUtil.isApp ? '_self' : '_blank'}' rel='noreferrer nofollow noopener' style='color:${color};' href='${link}'>${text}</a>`;
}

export function taskButtons(status, LG, fixLink, btn) {
  if ([TaskStatus.Init, TaskStatus.Progress, TaskStatus.Expired].includes(status)) {
    return [
      {
        disabled: status === TaskStatus.Expired,
        ...btn,
      },
    ];
  }
  if (status === TaskStatus.BonusClaimed) {
    return [
      {
        text: LG(lang.CheckVoucher),
        handleClick: genButtonHandler(fixLink, 'checkVoucher'),
      },
    ];
  }
  return [];
}

function versionToNum(appVersion) {
  return appVersion
    .toString()
    .split('.')
    .map((o, index) => Number(o) * Math.pow(10, (2 - index) * 2))
    .reduce((p, c) => p + c, 0);
}
